// extracted by mini-css-extract-plugin
export default {"root__btn":"style-module__root__btn___cxnBg","root__wrapper":"style-module__root__wrapper___FtHdQ","root__wrapper_item":"style-module__root__wrapper_item___T2PuY","root__wrapper_close":"style-module__root__wrapper_close___f1fTR"};
    if(module.hot) {
      // 1729151133388
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  